import { immerable } from 'immer'
import { Edge } from '../../entities'
import type { AbstractEdge } from '../../types'
import { getRotate, getTextPoint, getTextTransform } from '../../utils'
import { getPath } from './utils'

export class NormalGraphEdge extends Edge implements AbstractEdge {
  [immerable] = true

  /**
   * 获取边的路径
   *
   * @returns 边路径
   */
  getPath = () => {
    const { id, sourceNode, targetNode, undirected, strokeWidth } = this

    if (sourceNode == null || targetNode == null) {
      console.log('id', id, this)
      throw new Error(`edge ${this.id} does not have a start and end node`)
    }

    const d = getPath({
      arrowsWidth: undirected ? 0 : 1,
      strokeWidth,
      edge: this,
      edges: this.graph.edges as NormalGraphEdge[],
      sourceNode,
      targetNode,
    })
    const textPoint = getTextPoint(d)
    const textTransform = getTextTransform(
      textPoint,
      getRotate(sourceNode, targetNode)
    )

    return {
      d,
      textPoint,
      textTransform,
    }
  }
}
